import React, { FC, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import i18next from 'i18next';
import { useDispatch } from 'react-redux';
import { LoginPageProps } from '~/pages/LoginPage/LoginPage';
import { ChangePasswordPageProps } from '~/pages/ChangePasswordPage/ChangePasswordPage';
import { ChangePasswordConfirmPageProps } from '~/pages/ChangePasswordConfirmPage/ChangePasswordConfirmPage';
import AxiosSetup from '~/components/AxiosSetup';
import NotFoundRedirectPage from '~/pages/NotFoundPage/NotFoundRedirectPage';
import { IaTheme } from 'ia-react-core';
import { GetDealersExperience, DisplayBody } from '~/utils/dealerUtils';
import { contentRequested } from './App.actions';
import CustomPageLoader from '../components/CustomPageLoader';
import MainLayout from '../layouts/MainLayout/MainLayout';
import FormLayout from '../layouts/FormLayout/FormLayout';
import MobileLayout from '../layouts/MobileLayout/MobileLayout';
import Constants from './Constants';

const LoginPage = (props: LoginPageProps) => <CustomPageLoader loader={() => import('../pages/LoginPage')} {...props} />;
const ChangePasswordPage = (props: ChangePasswordPageProps) => <CustomPageLoader loader={() => import('../pages/ChangePasswordPage')} {...props} />;
const ChangePasswordConfirmPage = (props: ChangePasswordConfirmPageProps) => <CustomPageLoader loader={() => import('../pages/ChangePasswordConfirmPage')} {...props} />;
const LoggingTestPage = () => <CustomPageLoader loader={() => import('../pages/LoggingTestPage')} />;
const AccessErrorPage = () => <CustomPageLoader loader={() => import('~/pages/AccessErrorPage')} />;
const TechnicalErrorPage = () => <CustomPageLoader loader={() => import('~/pages/TechnicalErrorPage')} />;
const NotFoundPage = () => <CustomPageLoader loader={() => import('~/pages/NotFoundPage')} />;

export interface AppProps {
  theme: IaTheme;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const App: FC<AppProps> = ({ theme }) => {
  DisplayBody();

  useEffect(() => {
    document.body.id = GetDealersExperience();
  }, []);
  const dispatch = useDispatch();
  const lang = i18next.language;
  const isMobileIndicatorStored = (sessionStorage.getItem('mobileDeviceMode') === 'true');
  useEffect(() => {
    dispatch(contentRequested(lang));
  }, [dispatch, lang]);
  return (
    <MainLayout>
      <AxiosSetup />
      <Routes>
        <Route
          path={Constants.Pages.home}
          element={
            isMobileIndicatorStored ?
              <MobileLayout>
                <LoginPage />
              </MobileLayout>
              :
              <FormLayout>
                <LoginPage />
              </FormLayout>
          }
        />
        <Route
          path={Constants.Pages.changePassword}
          element={
            isMobileIndicatorStored ?
              <MobileLayout>
                <ChangePasswordPage />
              </MobileLayout>
              :
              <FormLayout>
                <ChangePasswordPage />
              </FormLayout>
          }
        />
        <Route
          path={Constants.Pages.changePasswordConfirm}
          element={
            isMobileIndicatorStored ?
              <MobileLayout>
                <ChangePasswordConfirmPage />
              </MobileLayout>
              :
              <FormLayout>
                <ChangePasswordConfirmPage />
              </FormLayout>
          }
        />
        <Route
          path={Constants.Pages.loggingTest}
          element={
            <FormLayout>
              <LoggingTestPage />
            </FormLayout>
          }
        />
        <Route
          path={Constants.Pages.accessError}
          element={
            <FormLayout>
              <AccessErrorPage />
            </FormLayout>
          }
        />
        <Route
          path={Constants.Pages.technicalError}
          element={
            <FormLayout>
              <TechnicalErrorPage />
            </FormLayout>
          }
        />
        <Route
          path={Constants.Pages.notFound}
          element={
            <FormLayout>
              <NotFoundPage />
            </FormLayout>
          }
        />
        <Route
          path={Constants.Pages.catchAll}
          element={
            <NotFoundRedirectPage />
          }
        />
      </Routes>
    </MainLayout>
  );
};

export default App;
